'use client'

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

type JargonTipPopoverProps = {
  label: React.ReactNode
  definition: string
  ariaLabel: string
  colour: 'purple' | 'green'
}

export function JargonTipPopover({ label, definition, ariaLabel, colour }: JargonTipPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger
        className={`jargon-tip jargon-tip-${colour} cursor-pointer`}
        style={{ filter: 'url(#jargon-rough)' }}
        aria-label={ariaLabel}
      >
        {label}
      </PopoverTrigger>
      <PopoverContent
        side="top"
        sideOffset={8}
        className="border-brand-purple/20 max-w-xs rounded-sm border bg-[#f8f6fa] p-4 text-sm leading-relaxed text-[#3a3a3a] shadow-lg"
      >
        {definition}
      </PopoverContent>
    </Popover>
  )
}
